module.exports = __webpack_public_path__ + "img/estalagem20.0e21d171.jpg";